import { BASE } from "./index";
import axios from "./http";

const aftersale = {

  //平台介入筛选条件
  favoriteslist: (params) =>
    axios.post(`${BASE.PRO1}/aftersale/select/map`, params),
};

export default aftersale;
